<template lang="jade">
.outer(v-if="showOption")
  span(v-for='(key, option) in options' v-bind:data-bgColor='key')
    input(type='radio' v-bind:value='option.value' id='{{ nameProp + key }}' name='{{ nameProp }}' v-model='output')
    label(for='{{ nameProp + key }}') {{option.label}}
</template>

<script>
export default {
  props: {
    showOption: {
      type: Boolean,
      default: true
    },
    options: {
      type: Array,
      default: []
    },
    output: {
      type: String,
      twoWay: true
    },
    nameProp: {
      type: String,
      default: 'tagTypeCheckbox'
    }
  },
  components: {
  },
  data () {
    return {
    }
  }, // close data
  computed: {
  },
  asyncData () {
  },
  methods: {
  },
  ready () {
  },
  events: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='scss' scoped>
  @import '~__vendor_variables_scss__';
  @import '~sass/_breakpoint.scss';

  span{
    float: left;
    font-size: 14px;
    padding-left: 5px;
    padding-right: 5px;
    @include breakpoint(md){
      padding-left: 8px;
      padding-right: 8px;
    }
    @include breakpoint(lg){
      padding-left: 8px;
      padding-right: 8px;
    }
    text-transform: capitalize;
  }
  label{
    cursor: pointer;
  }
  .outer{
    span{
      position: relative;
      input{
        position: absolute;
        left: -9999px;
      }
      & input + label {
        width: 100%;
        padding: 5px 3px;
        background-color: $MultiBanks_unchecked_bg;
        color: $MultiBanks_unchecked_fg;
        @include breakpoint(md){
          padding: 10px 6px;
          font-size: 14px;
        }
        @include breakpoint(lg){
          padding: 10px 6px;
          font-size: 14px;
        }
      }
      & input:checked + label {
        background-color: $MultiBanks_checked_bg;
        color: $MultiBanks_checked_fg;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// Single-Banks.vue?6834c3e9